// removed by extract-text-webpack-plugin
module.exports = {"component":"src-components-Header----Header-module---component---2wP_t","navContainer":"src-components-Header----Header-module---navContainer---17soM","brandContainer":"src-components-Header----Header-module---brandContainer---XbKCu","brand":"src-components-Header----Header-module---brand---34r6-","brandName":"src-components-Header----Header-module---brandName---39hpj","logo":"src-components-Header----Header-module---logo---2Zf4H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.module.scss
// module id = 181
// module chunks = 104101334113578 114276838955818